/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class HubspotService {

  private listCache: any[] = [];
  private fieldCache: any[] = [];

  constructor(private http: HttpClient) { }

  getFields(): Observable<any> {
    if (this.fieldCache.length > 0) {
      return Observable.of(this.fieldCache);
    }

    return this.http
      .get(
      `/api/v1/hubspot/fields`
      )
      .map((response: any) => {
        this.fieldCache = response || [];
        return this.fieldCache;
      });
  }

  getLists(useCache: string = 'true'): Observable<any> {


    return this.http
      .get(
      `/api/v1/hubspot/lists?cache=${useCache}`
      );
  }

  searchEmail(accountId: string, emailAddress: string) {
    return this.http.post(
      `/api/v1/admin/hubspot/findemail`,
      JSON.stringify({ accountId: accountId, emailAddress: emailAddress })
    );
  }

  grantAccess(code): Observable<any> {
    return this.http
      .post(
      `/api/v1/hubspot/grant`,
      { code: code }
      );
  }

  clearListCache() {
    this.listCache = [];
  }

  clearFieldCache() {
    this.fieldCache = [];
  }

  clearAll() {
    this.listCache = [];
    this.fieldCache = [];
  }
}



// WEBPACK FOOTER //
// ./client/app/services/hubspot.service.ts